import React from "react";
import cardTeam from "../../../data/cardTeam.json";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import {BiPhone } from "react-icons/bi";
import { HiOutlineMail } from "react-icons/hi";
import {ImInstagram} from "react-icons/im";
import {RiPinterestLine} from "react-icons/ri";
import "./style.css";

function CardTeam() {
  return (
    <div className="pt-5">
      <div className="row">
        {cardTeam.cardTeam.map((item, index) => (
          <div className="col-3 px-4" key={index}>
            <div className="team-img">
              <img src={item.img} alt="team" width="100%" />
            </div>

            <div className="pt-3 py-4">
              <p className="fw-bold">{item.name}</p>
              <p className="pt-2 t-grey">{item.position}</p>
              <p className="pt-3 t-grey">{item.text}</p>
            </div>

            <div className="py-4 border_top">
              <div className="d-flex align-items-center">
                <BiPhone className="me-2" />
                <p>{item.phone}</p>
              </div>

              <div className="d-flex align-items-center mt-2">
                <HiOutlineMail className="me-2" />
                <p>{item.email}</p>
              </div>
            </div>

            <div className="pt-4 border_top">
              <a href="#">
                <FaFacebookF className="icon_facebook me-2" />
              </a>
              <a href="#">
                <FaTwitter className="icon_twitter me-2" />
              </a>
              <a href="#">
                <RiPinterestLine className="icon_pinterest me-2" />
              </a>
              <a href="#">
                <ImInstagram className="icon_camera me-2" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CardTeam;
